import { defineComponent } from "vue";
import TUIRoomEngine__default from "@tencentcloud/tuiroom-engine-js";
import Dialog from "../../common/base/Dialog/index.mjs";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import TuiButton from "../../common/base/Button.vue.mjs";
import Input from "../../common/base/Input/index.mjs";
import ArrowStrokeSelectDownIcon from "../../common/icons/ArrowStrokeSelectDownIcon.vue.mjs";
import useUserInfo from "./useUserInfoHooks.mjs";
import Avatar from "../../common/Avatar.vue.mjs";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import "../../../locales/index.mjs";
import "../../../utils/environment.mjs";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import renderMsg from "../../common/base/Message/Message.mjs";
import { MESSAGE_DURATION } from "../../../constants/message.mjs";
import { useBasicStore } from "../../../stores/basic.mjs";
import { useRoomStore } from "../../../stores/room.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UserInfoPC",
  props: {
    userId: null,
    userName: null,
    avatarUrl: null,
    isShowEditName: { type: Boolean }
  },
  emits: ["log-out", "update-user-name"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const userInfoConfig = roomService.getComponentConfig("UserInfo");
    const basicStore = useBasicStore();
    const roomStore = useRoomStore();
    const {
      t,
      showUserControl,
      isUserNameEditorVisible,
      userInfoRef,
      tempUserName,
      handleUserControl,
      showEditUserNameDialog,
      closeUserNameEditor
    } = useUserInfo();
    async function saveUserName(userName) {
      const { userId } = props;
      if (userName.length === 0) {
        renderMsg({
          type: "warning",
          message: t("Username length should be greater than 0"),
          duration: MESSAGE_DURATION.NORMAL
        });
        return;
      }
      await TUIRoomEngine__default.setSelfInfo({
        userName,
        avatarUrl: roomStore.localUser.avatarUrl || ""
      });
      basicStore.setUserName(userName);
      roomStore.updateUserInfo({ userId, userName });
      emits("update-user-name", userName);
      closeUserNameEditor();
    }
    return { __sfc: true, emits, userInfoConfig, basicStore, roomStore, t, showUserControl, isUserNameEditorVisible, userInfoRef, tempUserName, handleUserControl, showEditUserNameDialog, closeUserNameEditor, props, saveUserName, Dialog, SvgIcon, TuiButton, TuiInput: Input, ArrowStrokeSelectDownIcon, Avatar };
  }
});
export {
  _sfc_main as default
};
